export function csvEscape(value: string | number | null | undefined): string {
  const text = String(value ?? '')
  return `"${text.replace(/"/g, '""')}"`
}

export function buildCampaignCsvFilename(prefix: string, campaignSlug: string): string {
  const safeSlug = campaignSlug
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
  const dateStamp = new Date().toISOString().slice(0, 10)
  const slugPart = safeSlug || 'campanha'
  return `${prefix}-${slugPart}-${dateStamp}.csv`
}

export function downloadCsvFile(csvContent: string, filename: string): void {
  const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' })
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename
  link.rel = 'noopener'
  link.click()
  URL.revokeObjectURL(objectUrl)
}
